import { render } from "./NickNameDialog.vue?vue&type=template&id=c395de26&scoped=true"
import script from "./NickNameDialog.vue?vue&type=script&lang=js"
export * from "./NickNameDialog.vue?vue&type=script&lang=js"

import "./NickNameDialog.vue?vue&type=style&index=0&id=c395de26&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c395de26"]])

export default __exports__